// Canonical Organization entity for mindbodygreen.
//
// Every page attributes editorial authority to THIS node and references it by
// `@id` — never by re-declaring `name`/`logo`/`sameAs` inline. Keeping the
// literals in one module is what prevents the drift that previously had three
// different social fingerprints live for one brand (homepage, shop, and the
// article publisher each disagreed).
//
// Every `sameAs` URL below was verified to resolve on 2026-08-05:
//   - YouTube is the channel-ID URL because all three handle forms
//     (/@mindbodygreen, /user/mindbodygreen, /mindbodygreen) declare it as their
//     canonical, and a channel id survives handle renames.
//   - LinkedIn's slug is `mindbodygreen-com`; bare `mindbodygreen` is a 404.
//   - Instagram needs the `www.` host; the bare host 301s to it.
//   - Crunchbase is deliberately ABSENT: it could not be verified (403), and a
//     sameAs pointing at a wrong profile harms entity reconciliation more than
//     omitting one does. Add it only once confirmed in a browser.
export const ORGANIZATION_ID = "https://www.mindbodygreen.com/#organization"
export const LOGO_ID = "https://www.mindbodygreen.com/#logo"
export const WEBSITE_ID = "https://www.mindbodygreen.com/#website"

// The ONLY way to attribute something to the org. Use for `publisher`, `worksFor`, etc.
export const organizationRef = { "@id": ORGANIZATION_ID }

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": ORGANIZATION_ID,
  "name": "mindbodygreen",
  "url": "https://www.mindbodygreen.com",
  "logo": {
    "@type": "ImageObject",
    "@id": LOGO_ID,
    "url":
      "https://mindbodygreen-res.cloudinary.com/image/upload/w_800,h_800/mbg_logo_short-square-2x.png",
    "width": 800,
    "height": 800,
  },
  "sameAs": [
    "https://www.facebook.com/mindbodygreen",
    "https://x.com/mindbodygreen",
    "https://www.instagram.com/mindbodygreen",
    "https://www.pinterest.com/mindbodygreen/",
    "https://www.youtube.com/channel/UCxAB39SRMVabVZEOKTo6iVA",
    "https://www.tiktok.com/@mindbodygreen",
    "https://www.linkedin.com/company/mindbodygreen-com",
  ],
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "telephone": "+1-877-624-9355",
      "email": "support@mindbodygreen.com",
      "areaServed": "Worldwide",
      "availableLanguage": "English",
    },
  ],
}

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": WEBSITE_ID,
  "name": "mindbodygreen",
  "url": "https://www.mindbodygreen.com",
  "publisher": organizationRef,
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://www.mindbodygreen.com/search?q={search_term}",
    },
    "query-input": "required name=search_term",
  },
}
